import { api } from '@/store/api' // Importa a sua instância do Axios

const state = {}
const getters = {}
const mutations = {}

const actions = {
  /**
   * Ação genérica para requisições GET.
   * @param {object} context - Contexto do Vuex (não usado aqui).
   * @param {object} payload - Objeto com a URL e os parâmetros.
   */
  async get(context, { url, params = {}, headers = {}, signal }) {
    try {
      const response = await api.get(url, { params, headers, signal })
      return { success: true, data: response.data }
    } catch (error) {
      console.error(`[Vuex API Module] GET Error on ${url}:`, error)
      return { success: false, error: error.response?.data?.error || error.message }
    }
  },

  /**
   * Ação genérica para requisições POST.
   * @param {object} context - Contexto do Vuex (não usado aqui).
   * @param {object} payload - Objeto com a URL e os dados.
   */
  async post(context, { url, data = {}, headers = {}, onUploadProgress, signal }) {
    try {
      const response = await api.post(url, data, { headers, onUploadProgress, signal })
      return { success: true, data: response.data }
    } catch (error) {
      console.error(`[Vuex API Module] POST Error on ${url}:`, error)
      return { success: false, error: error.response?.data?.error || error.message }
    }
  }
}

export default {
  namespaced: true, // Importante para poder chamar 'api/get'
  state,
  getters,
  actions,
  mutations
}
